import { render } from "./PointChainRating.vue?vue&type=template&id=d736fbd8&scoped=true"
import script from "./PointChainRating.vue?vue&type=script&lang=js"
export * from "./PointChainRating.vue?vue&type=script&lang=js"

import "./css/style.css?vue&type=style&index=0&id=d736fbd8&scoped=true&lang=css"

import exportComponent from "/Users/pmerkuloff/Web/hlv/FRONT/hpanel/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-d736fbd8"]])

export default __exports__